import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'service-route-legs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
